<template>
  <div class="course-details">
    <div class="course-title course-detail-item">
      <i class="fas fa-graduation-cap fa-fw" />
      <div class="course-detail-text tdesk-neutral-ultradark">
        <strong class="tdesk-neutral-ultradark">{{ unitCode }}</strong>
        {{ unitDescriptor }}

        <div class="tdesk-neutral-dark">
          {{ unitSubheading }}
        </div>
      </div>
    </div>

    <div v-if="isCorrectComponent && isValidFeeType" class="course-detail-item">
      <i class="fas fa-circle-dollar fa-fw" />
      <div v-if="courseFeeType === 'per_person' && courseFee" class="course-detail-text tdesk-neutral-ultradark">
        ${{ Number(courseFee).toFixed(2) }} per person
      </div>
      <div v-if="courseFeeType === 'no_charge'" class="course-detail-text tdesk-neutral-ultradark">
        No Charge
      </div>
    </div>

    <div class="course-detail-item">
      <i class="fas fa-map fa-fw" />
      <div class="course-detail-text">
        <div>{{ venueName }}</div>
        <span style="white-space: pre-line">{{ location }}</span>
      </div>
    </div>

    <div class="course-detail-item">
      <i class="fas fa-calendar-alt fa-fw" />
      <div>
        <div v-for="session in sessions" :key="session" class="course-detail-text">
          {{ session }} {{ timezoneAbbreviation }}
        </div>
      </div>
    </div>
    <div v-if="unitConstituents && unitConstituents.length" class="course-detail-item">
      <i class="fas fa-file-certificate fa-fw" />
      <div class="course-detail-text">
        The following additional units will also be included:
        <span v-for="constituent in unitConstituents" :key="constituent.code" style="display: block; height: 17px;">
          <span class="TDESK-H4">{{ constituent.code }}</span> <span class="tdesk-body--small">{{ constituent.descriptor }}</span>
        </span>
      </div>
    </div>
    <slot name="booking-type" />
    <slot name="timer" />
  </div>
</template>
<script>
  export default {
    props: {
      venueName: { type: String, required: true },
      unitConstituents: { type: Array, required: false, default: () => [] },
      location: { type: String, required: true },
      sessions: { type: Array, required: true },
      unitCode: { type: String, required: true },
      unitDescriptor: { type: String, required: true },
      unitSubheading: { type: String, required: false, default: null },
      timezoneAbbreviation: { type: String, required: true },
      courseFee: { type: String, required: false, default: null },
      courseFeeType: { type: String, required: false, default: null },
      currentComponent: { type: String, required: false, default: null },
    },
    computed: {
      isCorrectComponent() {
        return this.currentComponent === 'ScopeSelection' || 
               this.currentComponent === 'SelfInclusionSelection';
      },
      isValidFeeType() {
        return this.courseFeeType === 'per_person' || 
               this.courseFeeType === 'no_charge';
      },
    },
  };
</script>
